import React from 'react';

import './ErrorList.scss';

const ErrorList = (props) => {
  return <li>{props.name}</li>;
};

export default ErrorList;
